export default __webpack_public_path__ + "overview-1200-6163238fab23093b34492d36f93213c7.webp";